import {Component, EventEmitter, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {UtilService, CustomMessageService} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {Category} from "projects/store/src/app/enums";

@Component({
  selector: 'app-sales-client-identification',
  templateUrl: './sales-client-identification.component.html'
})
export class SalesClientIdentificationComponent {
  categoryCode: string;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter()

  constructor(private utilService: UtilService,
              private requestService: RequestService,
              private customMessageService: CustomMessageService,
              private route: ActivatedRoute) {
    this.categoryCode = this.route.snapshot.params['category_code'];
  }

  ngOnInit() {

  }

  onNextStep(data?: any) {
    this.nextStepEvent.emit(data);
  }

  onGotoStep(stepCode: string) {
    this.gotoStepEvent.emit(stepCode);
  }

  protected readonly Category = Category;
}
